import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const NowIndicatorLabel = () => {
  const [topOffset, setTopOffset] = useState(0);
  const [currentTime, setCurrentTime] = useState(moment());

  const calendarStartHour = 7;
  const calendarEndHour = 22;

  useEffect(() => {
    const updateNowIndicator = () => {
      const timeContent = document.querySelector(".rbc-time-content");

      if (timeContent) {
        const contentHeight = timeContent.getBoundingClientRect().height;
        const totalVisibleMinutes = (calendarEndHour - calendarStartHour) * 60;

        const now = moment.tz("Pacific/Auckland");
        const nowMinutes = now.hours() * 60 + now.minutes();
        const minutesSinceCalendarStart = nowMinutes - calendarStartHour * 60;

        if (
          minutesSinceCalendarStart < 0 ||
          minutesSinceCalendarStart > totalVisibleMinutes
        ) {
          setTopOffset(-9999);
        } else {
          const top =
            (minutesSinceCalendarStart / totalVisibleMinutes) * contentHeight;
          setTopOffset(top);
        }
        setCurrentTime(now);
      }
    };

    updateNowIndicator();
    const interval = setInterval(updateNowIndicator, 10000); // every 10s
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="absolute z-50 flex items-center pointer-events-none transition-all duration-500 ease-in-out"
      style={{
        top: `${topOffset + 245}px`,
        left: "1rem",
        transform: "translateY(-50%)",
      }}
    >
      {/* 🟥 Red Dot */}
      <div className="w-2.5 h-2.5 bg-rose-500 rounded-full shadow-md mr-2" />

      {/* 🕒 Time Label */}
      <div className="animate-pulse bg-white border-[2px] border-rose-400 text-rose-500 font-semibold px-2 py-0.5 rounded-full text-xs shadow">
        {currentTime.format("HH:mm")}
      </div>
    </div>
  );
};

export default NowIndicatorLabel;
